class SocialShare {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this.init();
        }
    }

    init() {
        this.$socialLinks = this.$el.find('.social-share__link');
        this.$emailShareForm = this.$el.find('.social-share__email-form');
        this.$closeShareFormBtn = this.$el.find('.social-share__close-button');

        if(this.$socialLinks.length) {
            this._initEmailShareForm();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onShareFn = this._onShare.bind(this);
        this.onMailShareFn = this._onMailShare.bind(this);
        this.closeShareFormFn = this._closeShareForm.bind(this);

        this.$socialLinks.on('click', this.onShareFn);

        if(this.$emailShareForm.length) {
            this.$emailShareForm[0].addEventListener('wpcf7mailsent', this.onMailShareFn, false );
        }
        if(this.$closeShareFormBtn.length) {
            this.$closeShareFormBtn.on('click', this.closeShareFormFn);
        }
    }

    _initEmailShareForm() {
        if(this.$emailShareForm.length) {
            const $messageField = this.$emailShareForm.find('textarea');

            if($messageField.length) {
                $messageField.text(window.location.href);
            }
        }
    }

    _onShare(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);

        if(!$target.hasClass('social-share__link--mail')) {
            if($target.hasClass('social-share__link--twitter')) {
                window.open($target.attr('href'), 'Twitter', 'height=300,width=550,resizable=1');
            }
            else if($target.hasClass('social-share__link--facebook')) {
                window.open($target.attr('href'), 'Facebook', 'height=300,width=550,resizable=1');
            }
            else if($target.hasClass('social-share__link--linkedin')) {
                window.open($target.attr('href'), 'LinkedIn', 'height=606,width=586,resizable=1');
            }
        }
        else {
            if(this.$emailShareForm.length) {
                this.$emailShareForm.toggleClass('social-share__email-form--displayed');
            }
        }
    }

    _onMailShare(e) {
        const $emailField = this.$emailShareForm.find('input[type=email]');
        const $messageField = this.$emailShareForm.find('textarea');

        if($emailField.length) {
            $emailField.val('');
        }

        if($messageField.length) {
            $messageField.text(window.location.href);
        }
    }

    _closeShareForm(e) {
        e.preventDefault();

        this.$emailShareForm.removeClass('social-share__email-form--displayed');
    }
}

export default SocialShare;
